export const environment = {
  production: `true`,
  launchcontrolAdminDomain: `stage-admin.dealerteamwork.com`,
  launchcontrolApiDomain: `stage-api.dealerteamwork.com`,
  autoDomain: `auto-api.stage-admin.dealerteamwork.com`,
  autoPort: `443`,
  mpopDomain: `adflex-api.stage-admin.dealerteamwork.com`,
  envName: `undefined`
};
